<script>
  import ReboquistaService, {sugerirCodigoReboquista} from '../../../../domain/reboquista/services/reboquista'
  import { isArray, debounce } from 'lodash'
  import moment from 'moment'
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    components: {},
    nome: 'novo-reboquista',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        extraModel: {
          validadeCnh: null
        },
        data: {
          id: null,
          nome: null,
          rg: null,
          cnh: null,
          validadeCnh: null,
          codigo: null,
          ativo: 1,
          sequencialGrv: 1
        },
        codigoReboquista: {
          numero: null,
          existe: null
        }
      }
    },
    computed: {
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          ReboquistaService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              console.log(response)
              let data = response.data
              let validadeCnh = JSON.parse(JSON.stringify(data.validadeCnh))
              this.extraModel.validadeCnh = validadeCnh ? moment(validadeCnh.date).format('L') : null
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const data = JSON.parse(JSON.stringify(this.data))
        data.validadeCnh = this.extraModel.validadeCnh
        ReboquistaService.cadastrar(data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'config.reboquista.edit', params: {id: response.data.id}})
              alert('Reboquista cadastrado!')
              // this.atualizadoSucesso = true
              this.$router.push({name: 'config.reboquista.list'})
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      editarUsuario () {
        if (!this.data.usuario) {
          this.$router.push({name: 'usuario.novo', query: {reboquista: this.data.id}})
        } else {
          this.$router.push({name: 'usuarios.visualizar', params: {id: this.data.usuario.id}})
        }
      },
      checarNumeroGrv: debounce(function () {
        const numero = this.data.codigo
        if (numero === null || !numero.toString().trim().length) {
          this.codigoReboquista.existe = null
          return
        }
        this.codigoReboquista.existe = -1 // loading
        ReboquistaService.checarExistenciaCodigoReboquista(numero)
          .then(response => {
            this.codigoReboquista.existe = response.data.existe
          })
          .catch(error => {
            console.log(error)
            if (error.status === 404) {
              this.codigoReboquista.existe = false
            } else {
              this.codigoReboquista.existe = null
              alert('Ocorreu um erro ao checar a GRV')
            }
          })
      }, 300),
      sugerirCodigoReboquista () {
        sugerirCodigoReboquista()
        .then(response => {
          let {codigo} = response.data
          this.data.codigo = String(codigo).padStart(3, '0')
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Reboquistas</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.reboquista.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>

            <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1" @click.prevent="editarUsuario" v-if="data.id">
              <i class="fa fa-user-o m-r-xs"></i> {{!data.usuario ? 'Criar ' : ''}} Acesso
            </u-button>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">RG</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.rg"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">CNH</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cnh"/>
                </div>
              </div>

              <div class="form-group">
                <label for="validadeCnh" class="col-sm-4 control-label">Validade da CNH</label>
                <div class="col-sm-8">
                  <input type="text" placeholder="dd/mm/yyyy"
                         v-model="extraModel.validadeCnh"
                         v-mask="'##/##/####'" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Código</label>
                <div class="col-sm-2">
                  <input type="text" v-model="data.codigo" class="form-control" @keyup="checarNumeroGrv"/>
                  <span class="text-danger text-center" v-if="codigoReboquista.existe === true">
                    <i class="fa fa-times text-danger m-l-sm"></i> Código já cadastrado para outro reboquista
                  </span>
                  <span class="text-success text-center" v-if="codigoReboquista.existe === false">
                    <i class="fa fa-check text-success m-l-sm" ></i> Código disponível
                  </span>
                  <i class="fa fa-spinner fa-spin m-l-sm" v-if="codigoReboquista.existe === -1"></i>
                </div>
                <div class="col-sm-2">
                  <button class="btn btn-sm btn-default" @click="sugerirCodigoReboquista">Sugerir código</button>
                </div>
              </div>

			  <div class="form-group">
                <label class="col-sm-4 control-label">Ativo</label>
				<div class="col-sm-8">
                  <input type="checkbox" v-model="data.ativo">
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.reboquista.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoReboquista.vue?248f21f5